import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth } from '../firebase'; // Zorg ervoor dat dit pad correct is
import { getFirestore, doc, getDoc } from 'firebase/firestore'; // Voeg Firestore imports toe

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notification, setNotification] = useState(null); // Toegevoegde state voor meldingen

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async user => {
            if (user) {
                const db = getFirestore();
                const userDoc = await getDoc(doc(db, 'users', user.uid));
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setCurrentUser({ ...user, role: userData.role });
                } else {
                    setCurrentUser(user);
                }
            } else {
                setCurrentUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (notification) {
            const timer = setTimeout(() => {
                setNotification(null);
            }, 3000); // Reset de melding na 3 seconden

            return () => clearTimeout(timer); // Clear de timer bij unmounten
        }
    }, [notification]);

    const login = async (email, password) => {
        await auth.signInWithEmailAndPassword(email, password);
    };

    const logout = async () => {
        await auth.signOut();
        setNotification({ message: 'Je bent succesvol uitgelogd!', style: { backgroundColor: 'green', color: 'white' } }); // Stel de melding in bij uitloggen
    };

    return (
        <AuthContext.Provider value={{ currentUser, login, logout, notification, setNotification }}>
            {!loading && (
                <>
                    {notification && (
                        <div style={{ ...notification.style, position: 'fixed', top: 0, width: '100%', textAlign: 'center', padding: '10px' }}>
                            {notification.message}
                        </div>
                    )}
                    {children}
                </>
            )}
        </AuthContext.Provider>
    );
};

// Voeg deze functie toe
export const useAuth = () => {
    return useContext(AuthContext);
};
